export default __webpack_public_path__ + "css/supplierPurchases.bundle.css";